module.exports = "bundles/89b96574367c8aa7e194271b2aa4e61e.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-60.png
// module id = 133
// module chunks = 0